import { pushRoute } from '../../lib/router.js';
import React, { useEffect } from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import Time from 'react-time';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import { getOrgTermsContent } from '../../content/utils.js';
import {
  deleteTask,
  retrieveTasks,
  selectRetrieveTasksState,
  selectTask,
} from '../../modules/tasks.js';
import {
  retrieveProject,
  selectProject,
  selectRetrieveProjectState,
} from '../../modules/projects.js';
import {
  retrieveChangeImpacts,
  selectChangeImpact,
  selectRetrieveChangeImpactsState,
} from '../../modules/changeImpacts.js';
import Empty from '../../components/Empty.jsx';
import TaskHeader from '../../components/headers/PageHeaders/Project/Task/TaskHeader.jsx';
import SubHeader from '../../components/SubHeader.jsx';
import {
  ChangeImpactLink,
  EditTaskLink,
  ProjectLink,
} from '../../components/links/index.jsx';

import Editor from '../../components/editor/editor.jsx';

const mapStateToProps = (state, ownProps) => ({
  task: selectTask(state, ownProps),
  projectId: ownProps.projectId,
  project: selectProject(ownProps.projectId)(state),
  changeImpact: selectChangeImpact(ownProps.changeImpactId)(state),
  retrieveTasksSuccess: selectRetrieveTasksState(state).success,
  retrieveChangeImpactsSuccess: selectRetrieveChangeImpactsState(state).success,
  retrieveProjectSuccess: selectRetrieveProjectState(state).success,
});

const mapDispatchToProps = {
  retrieveTasks,
  deleteTask,
  retrieveChangeImpacts,
  retrieveProject,
};

const TaskDetailContainer = (props) => {
  const {
    slug,
    task,
    changeImpact,
    projectId,
    project,
    changeImpactId,
    retrieveTasks,
    retrieveChangeImpacts,
    retrieveProject,
    retrieveProjectSuccess,
    retrieveTasksSuccess,
    retrieveChangeImpactsSuccess,
    deleteTask,
  } = props;
  const taskDescription = task?.description
    ? JSON.parse(task.description)
    : null;
  const taskDetailModalEditorOptions = {
    holder: 'task-details-modal-editor',
    readOnly: true,
    minHeight: 0,
  };

  const goBack = () =>
    pushRoute('projects/change-impacts/show', { projectId, changeImpactId });

  const onDeleteTask = () => {
    if (project.archived) {
      window.alert(getOrgTermsContent('archivedProjectMessage'));
    } else {
      if (!window.confirm('Are you sure you want to delete this task?')) return;
      deleteTask(task.id).then(() => goBack());
    }
  };

  useEffect(() => {
    !retrieveChangeImpactsSuccess && retrieveChangeImpacts(projectId);
    !retrieveTasksSuccess && retrieveTasks(changeImpactId);
    !retrieveProjectSuccess && retrieveProject(projectId);
  }, []);

  return project && changeImpact && task ? (
    <React.Fragment>
      <TaskHeader
        project={project}
        changeImpact={changeImpact}
        task={task}
        slug={slug}
      />
      <SubHeader flexJustify small>
        <h2>{task.title}</h2>
        {project.manageProjectEntities ? (
          project.archived ? (
            <div>
              <Button
                className="btn-primary"
                style={{ marginRight: '10px' }}
                onClick={() =>
                  window.alert(getOrgTermsContent('archivedProjectMessage'))
                }
              >
                Edit
              </Button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={onDeleteTask}
              >
                Delete
              </button>
            </div>
          ) : (
            <div>
              <EditTaskLink
                taskId={task.id}
                changeImpactId={changeImpactId}
                projectId={projectId}
              >
                <Button className="btn-primary" style={{ marginRight: '10px' }}>
                  Edit
                </Button>
              </EditTaskLink>
              <button
                type="button"
                className="btn btn-danger"
                onClick={onDeleteTask}
              >
                Delete
              </button>
            </div>
          )
        ) : null}
      </SubHeader>
      <Grid>
        <Row>
          <Col sm={12}>
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              <Row>
                <Col sm={10} smOffset={1}>
                  <Row>
                    <Col sm={3} md={2}>
                      <div className="text-muted m-b-24">Task Title:</div>
                      <div className="text-muted m-b-24">Task Status:</div>
                      <div className="text-muted m-b-24">Date Range:</div>
                      <div className="text-muted m-b-24">
                        Task {pluralize('Owner', changeImpact.owners.length)}:
                      </div>
                      <div className="text-muted m-b-24">Change Impact:</div>
                      <div className="text-muted m-b-24">
                        {getOrgTermsContent('project')}:
                      </div>
                    </Col>
                    <Col sm={9} md={10}>
                      <div className="m-b-24">{task.title}</div>
                      <div className="m-b-24">{task.status}</div>
                      <div className="m-b-24">
                        <Time value={task.startDate} format="M/D/YY" /> -
                        <Time value={task.endDate} format="M/D/YY" />
                      </div>
                      <div className="m-b-24">
                        {task.owners.length
                          ? task.owners.map((owner, index) => (
                              <React.Fragment key={index}>
                                <span
                                  className={`${owner.archived ? 'text-muted' : ''}`}
                                >
                                  {owner.name}
                                </span>
                                {index + 1 !== task.owners.length ? ', ' : null}
                              </React.Fragment>
                            ))
                          : '—'}
                      </div>
                      <div className="m-b-24">
                        <ChangeImpactLink
                          projectId={project.id}
                          changeImpactId={changeImpact.id}
                        >
                          {changeImpact.title}
                        </ChangeImpactLink>
                      </div>
                      <div className="m-b-24">
                        <ProjectLink projectId={project.id}>
                          {project.name}
                        </ProjectLink>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    {taskDescription ? (
                      <Col sm={12}>
                        <div
                          className="text-muted"
                          style={{ margin: '20px 0' }}
                        >
                          <strong>
                            Task Description:&nbsp;
                            {!(
                              taskDescription.hasOwnProperty('blocks') &&
                              taskDescription.blocks.length
                            ) ? (
                              <span className="text-muted">—</span>
                            ) : null}
                          </strong>
                        </div>

                        <div className="m-b-32">
                          {taskDescription.hasOwnProperty('blocks') &&
                          taskDescription.blocks.length ? (
                            <Editor
                              options={taskDetailModalEditorOptions}
                              data={taskDescription}
                            />
                          ) : null}
                        </div>
                      </Col>
                    ) : null}
                  </Row>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  ) : (
    <Empty simplified />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaskDetailContainer);
